import React from "react";
import Section1 from "./Section1";

export default function IndexPopup() {
  return (
    <div>
      <Section1 />
    </div>
  );
}